/* ================================================================
   TRUEDARTS — PREMIUM UI
   Depth, light, texture, weight
   ================================================================ */

(function() {
  'use strict';
  var D = window.innerWidth >= 768;

  function lerp(a, b, t) { return a + (b - a) * t; }

  /* ===== OBSERVER FACTORY ===== */
  function observe(selector, opts) {
    var els = document.querySelectorAll(selector);
    if (!els.length) return;
    var o = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          o.unobserve(entry.target);
        }
      });
    }, opts || { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) { o.observe(el); });
  }

  /* ===== SCROLL PROGRESS ===== */
  var bar = document.createElement('div');
  bar.className = 'scroll-progress';
  document.body.appendChild(bar);
  window.addEventListener('scroll', function() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
  }, { passive: true });

  /* ===== AURORA BACKGROUND (hero) ===== */
  var hero = document.querySelector('.hero');
  if (hero) {
    var aurora = document.createElement('div');
    aurora.className = 'aurora';
    aurora.innerHTML = '<div class="aurora__orb aurora__orb--1"></div><div class="aurora__orb aurora__orb--2"></div><div class="aurora__orb aurora__orb--3"></div>';
    hero.insertBefore(aurora, hero.firstChild);
  }

  /* ===== HERO SPOTLIGHT (mouse follow) ===== */
  if (D && hero) {
    var spot = document.createElement('div');
    spot.className = 'hero-spotlight';
    hero.appendChild(spot);
    var sx = 0, sy = 0, tx = 0, ty = 0;

    hero.addEventListener('mousemove', function(e) {
      tx = e.clientX;
      ty = e.clientY;
      spot.classList.add('is-active');
    });
    hero.addEventListener('mouseleave', function() {
      spot.classList.remove('is-active');
    });

    (function tick() {
      sx = lerp(sx, tx, 0.08);
      sy = lerp(sy, ty, 0.08);
      spot.style.left = sx + 'px';
      spot.style.top = sy + 'px';
      requestAnimationFrame(tick);
    })();
  }

  /* ===== PARTICLES ===== */
  if (D && hero) {
    for (var i = 0; i < 8; i++) {
      var p = document.createElement('div');
      p.className = 'particle';
      p.style.cssText = [
        '--size:' + (1 + Math.random() * 2.5) + 'px',
        '--px:' + (Math.random() * 200 - 100) + 'px',
        '--py:' + (-120 - Math.random() * 250) + 'px',
        '--duration:' + (10 + Math.random() * 10) + 's',
        '--delay:' + (Math.random() * 10) + 's',
        'left:' + (10 + Math.random() * 80) + '%',
        'bottom:' + (Math.random() * 40) + '%'
      ].join(';');
      hero.appendChild(p);
    }
  }

  /* ===== GLOW BORDER (hero image) ===== */
  var heroImg = document.querySelector('.hero__image.gradient-border');
  if (heroImg) {
    heroImg.classList.remove('gradient-border');
    heroImg.classList.add('glow-border');
  }

  /* ===== HERO PARALLAX ===== */
  if (D) {
    var hc = document.querySelector('.hero__content');
    var hi = document.querySelector('.hero__image-wrap');
    var hb = document.querySelectorAll('.hero__blob');
    if (hc) {
      window.addEventListener('scroll', function() {
        var y = window.scrollY;
        if (y > window.innerHeight) return;
        var p = y / window.innerHeight;
        hc.style.transform = 'translateY(' + (y * 0.25) + 'px)';
        hc.style.opacity = Math.max(0, 1 - p * 1.8);
        if (hi) hi.style.transform = 'translateY(' + (y * 0.08) + 'px)';
        hb.forEach(function(b, i) {
          b.style.transform = 'translateY(' + (y * (0.04 + i * 0.02)) + 'px)';
        });
      }, { passive: true });
    }
  }

  /* ===== WORD REVEAL (hero title) ===== */
  (function() {
    var title = document.querySelector('.hero__title');
    if (!title || title.dataset.wr) return;
    title.dataset.wr = '1';

    var html = title.innerHTML;
    var parts = html.split(/(<span[^>]*>.*?<\/span>)/);
    var out = '';

    function wrapWords(text) {
      return text.trim().split(/\s+/).filter(Boolean).map(function(w) {
        return '<span class="word-reveal-word"><span class="word-reveal-inner">' + w + '</span></span>';
      }).join(' ');
    }

    parts.forEach(function(part) {
      if (part.indexOf('<span') === 0) {
        var inner = part.replace(/<[^>]+>/g, '');
        var tag = part.match(/<span[^>]*>/)[0];
        out += tag + wrapWords(inner) + '</span>';
      } else if (part.trim()) {
        out += wrapWords(part);
      }
    });

    title.innerHTML = out;
    title.style.opacity = '1';

    var words = title.querySelectorAll('.word-reveal-word');
    words.forEach(function(el, i) {
      setTimeout(function() { el.classList.add('is-visible'); }, 300 + i * 90);
    });
  })();

  /* ===== MAGNETIC BUTTONS ===== */
  if (D) {
    document.querySelectorAll('.btn-primary, .btn-primary--sm, .hero__founders').forEach(function(btn) {
      btn.classList.add('btn-magnetic');
      btn.addEventListener('mousemove', function(e) {
        var r = btn.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + (x * 0.15) + 'px, ' + (y * 0.15) + 'px)';
      });
      btn.addEventListener('mouseleave', function() { btn.style.transform = ''; });
    });
  }

  /* ===== CARD HOVER WITH LIGHT ===== */
  if (D) {
    document.querySelectorAll('.bento__card, .stats__item, .review-card, .ps-card').forEach(function(card) {
      card.classList.add('card-premium');
      var light = document.createElement('div');
      light.className = 'card-premium__light';
      card.appendChild(light);
      card.addEventListener('mousemove', function(e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--light-x', (e.clientX - r.left) + 'px');
        card.style.setProperty('--light-y', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ===== SECTION REVEALS ===== */
  document.querySelectorAll(
    '.pain-solution-v2, .section--surface, .how, .stats, .reviews, .faq, .final-cta, .preorder, #vergelijk'
  ).forEach(function(el) { el.classList.add('section-reveal'); });
  observe('.section-reveal', { threshold: 0.06 });

  /* ===== STAGGER GRIDS ===== */
  document.querySelectorAll('.stats__grid, .bento, .reviews__grid, .how__steps').forEach(function(el) {
    el.classList.add('stagger');
  });
  observe('.stagger');

  /* ===== IMAGE CLIP REVEAL ===== */
  document.querySelectorAll('.how__image').forEach(function(el) { el.classList.add('clip-reveal'); });
  observe('.clip-reveal', { threshold: 0.2 });

  /* ===== HOW STEP LINE DRAW ===== */
  observe('.how__step', { threshold: 0.3 });

  /* ===== COUNTER ANIMATE ===== */
  var counterObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('counter-animate');
        counterObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('.stats__value').forEach(function(el) { counterObs.observe(el); });

})();
